import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  IconButton
} from '@mui/material';
import { 
  LockClock as LockClockIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SessionExpiredDialog = ({ open, onClose, reason = 'expired' }) => {
  const navigate = useNavigate();

  const handleRedirectToLogin = () => {
    onClose();
    // Guardar la razón de logout para mostrar en login
    sessionStorage.setItem('logoutReason', reason);
    navigate('/login');
  };

  const getReasonMessage = () => {
    switch(reason) {
      case 'expired':
        return 'Your session has expired for security. Please sign in again to continue.';
      case 'inactivity':
        return 'Your session has been closed due to prolonged inactivity. Please sign in again.';
      case 'invalid':
        return 'Your session is invalid. Please sign in again.';
      case 'concurrent':
        return 'Another active session has been detected. For security, this session has been closed.';
      default:
        return 'Your session has ended. Please sign in again.';
    }
  };

  const getReasonTitle = () => {
    switch(reason) {
      case 'expired':
        return 'Session Expired';
      case 'inactivity':
        return 'Session Closed Due to Inactivity';
      case 'invalid':
        return 'Invalid Session';
      case 'concurrent':
        return 'Duplicate Session';
      default:
        return 'Session Ended';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2,
        pb: 1
      }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1.5,
          flex: 1
        }}>
          <Box sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'warning.light',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <LockClockIcon sx={{ color: 'warning.dark' }} />
          </Box>
          <Typography variant="h6" component="span" fontWeight={600}>
            {getReasonTitle()}
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={handleRedirectToLogin}
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Alert 
          severity="warning" 
          sx={{ 
            mb: 2,
            '& .MuiAlert-message': {
              width: '100%'
            }
          }}
        >
          <Typography variant="body2">
            {getReasonMessage()}
          </Typography>
        </Alert>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No te preocupes, tu trabajo ha sido guardado automáticamente.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRedirectToLogin}
          fullWidth
          size="large"
          sx={{
            borderRadius: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.2
          }}
        >
          Go to Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
